import dayjs from 'dayjs'
import React from 'react'
import { Link } from 'react-router-dom'

import { TimezonedDateString } from '@modules/Timezone/components/TimezonedDateString'
import { routing } from '@utils/routing'

import { useSubscription } from './useSubscription'

type UsePastDueSubscriptionErrorBannerProps = {
  withLink?: boolean
}

export const usePastDueSubscriptionErrorBanner = ({
  withLink = false,
}: UsePastDueSubscriptionErrorBannerProps = {}) => {
  const { activeSubscription } = useSubscription()

  const isActive = !!activeSubscription && activeSubscription.status === 'PAST_DUE'
  const pastDueDate = activeSubscription?.activeTo
    ? dayjs(activeSubscription?.activeTo).add(3, 'day')
    : null

  const getContent = () => {
    if (!isActive) {
      return null
    }

    const updateText = withLink ? (
      <Link to={routing.settings.billing.self}>Update your payment method</Link>
    ) : (
      'Update your payment method'
    )

    return (
      <>
        Payment for Fourthwall Pro subscription failed. Please {updateText} or you’ll lose access to
        your Pro benefits
        {pastDueDate && (
          <>
            {' '}
            on <TimezonedDateString date={pastDueDate} />
          </>
        )}
        .
      </>
    )
  }

  return {
    isActive,
    content: getContent(),
  }
}
